import { render } from "./WpeSlider.vue?vue&type=template&id=96be86f8"
import script from "./WpeSlider.vue?vue&type=script&lang=js"
export * from "./WpeSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeSlider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "96be86f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('96be86f8', __exports__)) {
    api.reload('96be86f8', __exports__)
  }
  
  module.hot.accept("./WpeSlider.vue?vue&type=template&id=96be86f8", () => {
    api.rerender('96be86f8', render)
  })

}


export default __exports__